module.exports = __webpack_public_path__ + "img/checked.249af28b.png";